export default function hydrateCustomer(_args: CommandArgs) {
  function hydrate(): boolean {
    return false
  }

  return { hydrate }
}

declare global {
  export type HydrateCustomerCommands = ReturnType<typeof hydrateCustomer>

  // Add to global scope
  interface CommandRegistry {
    'hydrate/customer': HydrateCustomerCommands
  }
}
